import { GET_RETAIL_STORE_RESPONSE } from 'actions/baskets';

const initialState = {};
const addRetailStore = (state, action) => {
  const menuSlug = action.params.menuSlug;
  return {
    ...state,
    [menuSlug]: action.response.retailStore,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RETAIL_STORE_RESPONSE:
      return addRetailStore(state, action);
    default:
      return state;
  }
};

export const selectStoreForMenu = (state, menuSlug) => state[menuSlug];
